/*
A/B Header Test encapsulated for Adobe Target

Copy/paste everything in browser console to test.
When using Adobe Target, remember to add <script> tags at the beginning and end.

1) RE-BUILD FSI HEADER BANNER (gradient top bar)
1.1 E-store link swap logic
1.2 If top bar doesn't exist, create new one with just estore links
1.3 Otherwise build bar as usual

2) CURRENT MEGANAV VISIBILITY

3) BUILD NAVIGATION
3.1 Build desktop navigation
3.2 CSS

4) MEGA NAV LOGIC
4.1 Navigation data structure
4.2 Dropdown positioning
4.3 Sticky bars on SinglePDP pages

5) LOAD DEPENDING ON SCREEN SIZES

*/

const isUS = document.querySelector("#main-nav-header").getAttribute("data-locale") === "en_US";
const aemContainer = document.querySelector("main.container");
const aemContainerMargin = 170;
const hero = document.querySelector('#fs-cq-hro');
const heroMargin = 45;
const aemBreadcrumb  = document.querySelector('nav.cmp-breadcrumb');
const hasBreadcrumb = aemBreadcrumb && aemBreadcrumb.children.length > 0;
let currentChosenTab;

function switchToAltHeader() {

    // 1) RE-BUILD FSI HEADER BANNER (gradient top bar)

    // 1.1 E-store link swap logic
    // Changes links of first column depending on what site the user is on
    //data-analytics-section="Global Nav" data-analytics-container="Fisher Scientific"
    let estores = {
        "scientific": "Fisher Scientific",
        "healthcare": "Fisher Healthcare",
        "scied": "Fisher Education"
    }

    let mainContent = document.querySelector(".main");
    let siteCat = document.querySelector("header").getAttribute("data-estore");
    let topBarLinks;
    let estoreTranslation = estores[siteCat];
    let fisherSci = '<a href="/us/en/home.html" class="kmd-text-white-0 kmd-mr-sm-2" data-estore-cookie-banner="estore-scientific" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Scientific" data-analytics-text="Fisher Scientific">Fisher Scientific</a>';
    let fisherHealthcare = '<a href="/us/en/healthcare-products.html" class="kmd-text-white-0 kmd-mr-sm-2" data-estore-cookie-banner="estore-healthcare" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Healthcare" data-analytics-text="Fisher Healthcare">Fisher Healthcare</a>';
    let fisherSciEd = '<a href="/us/en/education-products.html" class="kmd-text-white-0 kmd-mx-sm-2" data-estore-cookie-banner="estore-scied" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Science Education" data-analytics-text="Fisher Science Education">Fisher Science Education</a>';

    //adjust AEM containers margin
    if(aemContainer){
        if(hero) {
            hero.style.marginTop = `${heroMargin}px`;
        } else {
            if(!hasBreadcrumb){
                aemContainer.style.setProperty("margin-top", `${aemContainerMargin}px`, "important");
            }
        }
    }

    if (siteCat == "scientific") {
        topBarLinks = fisherHealthcare + fisherSciEd;
    } else if (siteCat == "healthcare") {
        topBarLinks = fisherSci + fisherSciEd;
    } else if (siteCat == "scied") {
        topBarLinks = fisherSci + fisherHealthcare;
    } else {
        topBarLinks = fisherSci + fisherHealthcare + fisherSciEd;
    }

    //Only the US has more than one store, so this logic is only needed there

    // 1.2 If top bar doesn't exist, create new one with just estore links ONLY FOR US
    if(isUS) {
        if (!document.querySelector("#fs-headerfooter-hbr")) {
            document.querySelector(".user_name").insertAdjacentHTML("afterend", '<div id="fs-headerfooter-hbr" class="fallback-banner dynamic-offer desktop-banner fsi-header-banner kmd-d-justify-center kmd-d-flex kmd-d-align-center kmd-banner__gradiant">' + topBarLinks + '</div>');
            document.querySelector("header").classList.add("banner-transition"); // class for correct top spacing

            //Override the shim flag for the banner
            const headerShim = document.querySelector("#header-shim");
            const dummyElement = document.createElement('span')
            headerShim.classList.remove("banner-disabled");
            headerShim.classList.add("banner-enabled");
            //This will force the header to behave properly when no banner is present
            if (bannerDiv) {
                bannerDiv.appendChild(dummyElement);
            }
            // 1.3 Otherwise build bar as usual
        } else {
            const topBar = document.querySelector("#fs-headerfooter-hbr");
            topBar.classList.add("kmd-d-flex", "dynamic-offer", "desktop-banner", "kmd-d-justify-spacebetween", "kmd-d-align-center");
            const topBarHeaderBanner = document.querySelector(".fsi-header-banner");

            const topBarContainer = document.createElement("div");
            topBarContainer.className = "fs-headerfooter-cont kmd-d-flex kmd-d-align-center";
            topBarContainer.innerHTML = '\n    <div id="fsi-header-col-1" class="fsi-header-banner kmd-text-weight-500">\n          ' + topBarLinks + '\n    </div>\n';
            topBar.appendChild(topBarContainer);

            const topBarCol2 = document.createElement("div");
            topBarContainer.appendChild(topBarCol2);
            topBarCol2.setAttribute("id", "fsi-header-col-2");
            //TODO PUT A CHECK TO SEE IF A BANNER EXITS ALREADY, IF NOT ADD ONLY LINKS
            if (topBarHeaderBanner) {
                topBarCol2.appendChild(topBarHeaderBanner);
            }


            topBar.classList.add("kmd-banner__gradiant");

            try {
                topBarCol2.querySelector("a").classList.remove("fsi-header-banner", "kmd-banner__gradiant");
                topBarCol2.querySelector("a").classList.add("kmd-text-white-0");

                topBarCol2.querySelector("a > div").removeAttribute("style");

                topBarCol2.querySelector("a > div > div").classList.remove("kmd-py-1", "kmd-px-4", "kmd-px-lg-8");
                topBarCol2.querySelector("a > div > div").classList.add("kmd-pl-4", "kmd-pl-lg-8");

                topBarCol2.querySelector("a > div > div > div").classList.remove("kmd-text-sml");

                topBarCol2.querySelector("a > div > div > div > div:nth-child(2)").classList.add("kmd-d-align-items");

                topBarCol2.querySelector("svg").style.marginTop = "-4px";
            } catch (e) {
                //do nothing
                console.error(e);
            }
        }
    }

    // 2) CURRENT MEGANAV VISIBILITY
    // Use state "hide" or "show" for current meganav
    function hideDrawer(state) {
        const drawerNav = document.querySelector("#open-main-drawer");
        const drawerContent = document.querySelector(".drawer");

        if(!drawerNav || !drawerContent) return;

        if (state === "show") {
            drawerNav.classList.remove('hide');
            drawerNav.style.display = "block";
           // drawer content to be handled by drawer.js, so no need to set display here
        } else if (state === "hide") {
            drawerNav.classList.add('hide');
            drawerNav.style.display = "none";
            drawerContent.style.display = "none";
            drawerContent.ariaHidden = "true";
        } else {
            // nothing happens
        }
    }

    // 3) BUILD NAVIGATION

    function buildNav() {

        // 3.1 Build desktop navigation
        //const mN = document.querySelector("#mega-nav");
        const mN = document.querySelector("#main-nav-header");
        const nav = document.createElement("nav");
        nav.className = "navigation container-shadow";
        nav.setAttribute("id", "main-horizontal-nav");
        nav.setAttribute("aria-label", "Site navigation");
        const arrowSVG = `
	  <span class="dropdown-arrow">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 319 511.61">
		  <path
			d="M48.92 505.72 5.88 462.68c-7.85-7.85-7.83-20.72 0-28.54l178.35-178.35L5.88 77.44c-7.85-7.85-7.8-20.73 0-28.54L48.92 5.87c7.83-7.82 20.71-7.82 28.54 0l192.25 192.26.37.36 43.04 43.03c7.82 7.84 7.86 20.69 0 28.54l-43.04 43.04-.37.36L77.46 505.72c-7.85 7.86-20.68 7.86-28.54 0z"
		  />
		</svg>
	  </span>
	`;

    const navItemsHTML = Object.keys(navigationData)
        .sort((a, b) => Number(a) - Number(b)) // keep original order: 0,1,2…
        .map((key) => {
            const label = (navigationData[key] && navigationData[key].parentLabel) || "";
            let href = "#";
            let hasPopup = true;
            let arrow = arrowSVG;
            let linkOnly =
                navigationData[key] && navigationData[key].linkOnly
                    ? 'data-linkonly="true"'
                    : '';
            let cssClass = navigationData[key] && navigationData[key].cssClass ? navigationData[key].cssClass : '';

            if (!label) return "";

            if(linkOnly !== ''){
                href = (navigationData[key] && navigationData[key].href) || "#";
                hasPopup = false;
                arrow = '';
            }


            return `
              <div class="nav-item">
                <a href="${href}"
                   class="nav-link ${cssClass}"
                   role="menuitem"
                   aria-haspopup="${hasPopup}"
                   aria-expanded="false"
                   ${linkOnly}
                   data-nav-key="${key}">
                  ${label}
                  ${arrow}
                </a>
              </div>
            `;
        })
        .join("");

    nav.innerHTML = `
  <div class="nav-content">
    ${navItemsHTML}
  </div>
`;

        if(mN){
            mN.parentNode.insertBefore(nav, mN.nextSibling);
        }

        // create mega dropdown
        const megaDrop = document.createElement("div");
        megaDrop.className = "mega-dropdown";
        megaDrop.setAttribute("id", "universalDropdown");
        megaDrop.innerHTML = `\n      <div class="mega-dropdown-content">\n        <div class="mega-dropdown-sidebar" id="dropdownSidebar">\n          <!-- Sidebar content will be populated by JavaScript -->\n        </div>\n        <div class="mega-dropdown-main" id="dropdownMain">\n          <!-- Main content will be populated by JavaScript -->\n        </div>\n      </div>\n    `;
        nav.parentNode.insertBefore(megaDrop, nav.nextSibling);

        window.addEventListener('scroll', () => {
            if (window.scrollY > 30) {
                nav.classList.add('hidden');
            } else {
                nav.classList.remove('hidden');
            }
        });
    }




    // 4) MEGA NAV LOGIC

    function navLogic() {

        const universalDropdown = document.getElementById("universalDropdown");
        const dropdownSidebar = document.getElementById("dropdownSidebar");
        const dropdownMain = document.getElementById("dropdownMain");

        let currentActiveIndex = -1;
        const addedContentClasses = new Set(); // track dynamic classes added to dropdownContent

        // Body overlay
        let isPDP = false;
        const bodyID = document.querySelector("body").getAttribute("id");
        if (bodyID == "SinglePDP" || bodyID == "productDisplay" || bodyID == "itemDisplay") {
            isPDP = true;
            mainContent = document.querySelector(".main");
        } else if (document.querySelector("main")) {
            mainContent = document.querySelector("main");
        } else if (document.querySelector(".main-cart-section")) {
            mainContent = document.querySelector("#main")
        }

        function getContentWidthPDP() {
            if (bodyID == "SinglePDP") {
                return (1440 / window.innerWidth) * 100;
            }
            if (bodyID == "productDisplay" || bodyID == "itemDisplay") {
                return (1240 / window.innerWidth) * 100;
            }
        }

        const navigationBar = document.querySelector(".navigation");
        //Certain pages are having issues with the fixed nav - ReactJS in particular.  Skip them if so
        function skipFixedNav(){
            const skipPages = ['/store1/mylist',
                '/store1/order-approval/requisitions',
                '/store1/quotes',
                '/store1/account-dashboard',
            '/store1/subscriptionorders/'];
            const currentPath = window.location.pathname;
            return skipPages.some(page => currentPath.includes(page));
        }

        function addOverlay() {
            if (document.querySelector(".main-nav-header-overlay")) {
                // nothing happens
            } else {
                universalDropdown.insertAdjacentHTML("beforebegin", '<div class="main-nav-header-overlay"></div>');
                if(!skipFixedNav()) {
                    navigationBar.classList.add('fixednav');
                }
                document.body.classList.add('no-scroll');
                //Not all tabs will have maincontent due to link only
                if(mainContent) {
                    mainContent.classList.add('fixedcontent');

                    if (isPDP) {
                        mainContent.style.display = "block !important";
                        mainContent.style.margin = "0 auto !important";
                        //mainContent.style.width = getContentWidthPDP() + '%';
                        mainContent.style.maxWidth = "none !important";
                    }
                }
            }
        }

        function removeOverlay() {
            if (document.querySelector(".main-nav-header-overlay")) {
                const newOverlay = document.querySelector(".main-nav-header-overlay");
                newOverlay.remove();
                navigationBar.classList.remove('fixednav');
                document.body.classList.remove('no-scroll');

                //Not all tabs will have maincontent due to link only
                if(mainContent) {
                    mainContent.classList.remove('fixedcontent');

                    if (isPDP) {
                        mainContent.removeAttribute("style");
                    }
                }
            } else {
                // nothing happens
            }

        }

        let lastTabbableNavItem;
        let lastTabbableSidebarItem;

        function closeUniversalDropdown() {
            universalDropdown.classList.remove("active");
            document.querySelectorAll(".nav-item").forEach((item) => item.classList.remove("active"));
            removeOverlay();
            currentActiveIndex = -1;

            // Reset tabindex for all dropdown content
            const dropdownLinks = universalDropdown.querySelectorAll("button");
            dropdownLinks.forEach((link) => {
                link.setAttribute("tabindex", "-1");
            });
        }

        function openUniversalDropdown(index) {
            const navItems = document.querySelectorAll(".nav-item");

            navItems.forEach((navItem) => navItem.classList.remove("active"));
            navItems.forEach((navItem) => navItem.querySelector("a").setAttribute("aria-expanded", "false"));

            navItems[index].classList.add("active");
            navItems[index].querySelector("a").setAttribute("aria-expanded", "true");

            lastTabbableNavItem = document.querySelector(".nav-item.active .nav-link");
            currentActiveIndex = index;

            populateDropdown(index);

            // ✅ Hide BEFORE adding active class
            universalDropdown.classList.add("mega-menu-measuring");
            universalDropdown.classList.add("active");
            addOverlay();

            // Force layout calculation before positioning
            void universalDropdown.offsetHeight; // Force reflow

            // Wait for layout to settle, then position, then reveal
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // Position the menu
                    if (window.MegaMenuController && MegaMenuController.reposition) {
                        MegaMenuController.reposition();
                    } else if (typeof positionNow === "function") {
                        positionNow();
                    }

                    // Wait one more frame after positioning completes
                    requestAnimationFrame(() => {
                        universalDropdown.classList.remove("mega-menu-measuring");

                        // Make dropdown content tabbable
                        const dropdownLinks = universalDropdown.querySelectorAll("button");
                        dropdownLinks.forEach((link) => link.setAttribute("tabindex", "0"));

                        // Focus first tabbable element in dropdown
                        const firstTabbable = universalDropdown.querySelector("a, button");
                        if (firstTabbable) firstTabbable.focus();
                    });
                });
            });
        }


        function populateDropdown(index) {
            const data = navigationData[index];
            if (!data || data.linkOnly) return;

            // Populate sidebar
            dropdownSidebar.innerHTML = "";
            if(data.sidebar && !data.sidebar[0].hideSidebar) {
                data.sidebar.forEach((item, index) => {
                    const link = document.createElement("a");
                    const linkParent = data.parentLabel ? data.parentLabel : '';
                    link.href = "#";
                    link.className = 'sidebar-item ' + (item.active ? "active" : "");
                    link.setAttribute("data-target", item.id);
                    link.setAttribute("role", "menuitem");
                    link.setAttribute("aria-haspopup", "true");
                    link.setAttribute("aria-expanded", "false");
                    link.setAttribute('data-analytics-section', 'Horizontal Nav');
                    link.setAttribute('data-analytics-parent', linkParent);
                    link.setAttribute('data-analytics-container', estoreTranslation );
                    link.setAttribute('data-analytics-text', item.label + '|' + (index + 1));
                    link.textContent = item.label;
                    dropdownSidebar.classList.remove('hide');
                    dropdownContent.classList.remove('no-sidebar');
                    dropdownSidebar.appendChild(link);
                });
            }
            //For instances where there's no sidebar
            if(data.sidebar && data.sidebar[0].hideSidebar) {
                dropdownSidebar.classList.add('hide');
                dropdownContent.classList.add('no-sidebar');
            }

            //If extra CSS classes are needed
            if (data.cssClassForContent) {
                // Add only new classes, tracking them uniquely
                data.cssClassForContent.split(" ").forEach(cls => {
                    if (cls && !addedContentClasses.has(cls)) {
                        addedContentClasses.add(cls);
                        dropdownContent.classList.add(cls);
                    }
                });
            } else {
                // Remove all previously added dynamic classes
                addedContentClasses.forEach(cls => dropdownContent.classList.remove(cls));
                addedContentClasses.clear();
            }


            // Add footer if exists
            if (data.footer) {
                const footerDiv = document.createElement("div");
                let footerHref = false;
                footerDiv.className = "dropdown-footer";
                data.footer.forEach((linkData, i) => {
                    const link = document.createElement("a");
                    if(linkData.useLocale && linkData.href){
                        footerHref = localeUrlPath + linkData.href;
                    } else{
                        footerHref = linkData.href;
                    }
                    link.href = footerHref || "#";
                    link.textContent = linkData.text;
                    link.setAttribute('data-analytics-section', 'Horizontal Nav');
                    link.setAttribute('data-analytics-parent', '');
                    link.setAttribute('data-analytics-container', estoreTranslation + '|' + data.parentLabel);
                    link.setAttribute('data-analytics-text', linkData.text + '|' + (index + 1));
                    footerDiv.appendChild(link);
                });
                dropdownSidebar.appendChild(footerDiv);
            }

            // Populate main content
            const activeItem = data.sidebar.find(item => item.active);
            const activeId = activeItem && activeItem.id
                ? activeItem.id
                : data.sidebar[0].id;

            populateMainContent(data, activeId);

            // Add event listeners to sidebar items
            // Add event listeners to sidebar items
            let hoverTimer = null;
            const HOVER_DELAY = 300;

            dropdownSidebar.querySelectorAll(".sidebar-item").forEach((item) => {
                item.addEventListener("click", function(e) {
                    e.preventDefault();
                    clearTimeout(hoverTimer);
                    activateSidebarItem(this);
                });

                item.addEventListener("mouseenter", function() {
                    clearTimeout(hoverTimer);

                    if (this.classList.contains("active")) return;

                    hoverTimer = setTimeout(() => {
                        activateSidebarItem(this);
                    }, HOVER_DELAY);
                });

                item.addEventListener("mouseleave", function() {
                    clearTimeout(hoverTimer);
                });

                item.addEventListener("keydown", function(e) {
                    if (e.key === "Enter" || e.key === " " || e.key === "ArrowRight") {
                        e.preventDefault();
                        clearTimeout(hoverTimer);
                        activateSidebarItem(this);

                        setTimeout(() => {
                            const firstMainLink = dropdownMain.querySelector("a, button, .chemical-search-card, .special-offer-card");
                            if (firstMainLink) firstMainLink.focus();
                        }, 100);
                    }
                });
            });

        }

        function activateSidebarItem(sidebarItem) {
            dropdownSidebar.querySelectorAll(".sidebar-item").forEach((item) => {
                item.classList.remove("active");
                item.setAttribute("aria-expanded", "false");
            });
            sidebarItem.classList.add("active");
            lastTabbableSidebarItem = document.querySelector(".sidebar-item.active");
            sidebarItem.setAttribute("aria-expanded", "true");

            // Get the navigation data for current dropdown
            const data = navigationData[currentActiveIndex];
            if (data) {
                populateMainContent(data, sidebarItem.getAttribute("data-target"));

                // IMPORTANT: Make the new main content tabbable
                const newMainElements = dropdownMain.querySelectorAll("button");
                newMainElements.forEach((element) => {
                    element.setAttribute("tabindex", "0");
                });
            }
        }

        function populateMainContent(data, targetId) {
            const content = data.content[targetId];
            let shopAllHref = false;
            if (!content) return;

            if(content.shopAllHref && content.useLocale){
                shopAllHref = localeUrlPath + content.shopAllHref;
            }

            let h3Visibility = "";
            if (!content.visible) {
                h3Visibility = " kmd-d-none";
            }

            let shopOrBrowseAllText = shopAllText;

            if (content.shopAll) {
                if (content.titleId === "programs" || content.titleId === "services" || content.titleId === "applications") {
                    shopOrBrowseAllText = browseAllText;
                } else {
                    shopOrBrowseAllText = shopAllText;
                }
            }

            let html = '\n                <div class="mega-content-header' + h3Visibility + '">\n                    <h3 class="mega-content-title" id="' + content.titleId + '">' + content.title + '</h3>\n                    ' + (content.shopAll ? '<a  data-analytics-section="Horizontal Nav" data-analytics-container="' + estoreTranslation + '|' + data.parentLabel + '" data-analytics-parent="' + content.title + '" data-analytics-text="' + shopOrBrowseAllText + ' ' + content.title + '" href="' + (shopAllHref || "#") + '" class="shop-all-link" tabindex="-1" aria-label="' + shopOrBrowseAllText + ' ' + content.title + '">' + shopOrBrowseAllText + '</a>' : "") + '\n                </div>\n            ';

            if (content.type === "text") {
                html += '<p class="mega-content-description">' + content.description + '</p>';
            } else if (content.type === "cards" && content.cards) {
                html += '<div class="special-offers-grid">';
                content.cards.forEach((card, index) => {
                    html += '\n                        <a data-analytics-section="Horizontal Nav" data-analytics-container="' + estoreTranslation  + '|' + data.parentLabel + ' " data-analytics-parent="' + content.title + '" data-analytics-text="Special Offer ' + card.title + '|' + index + '" href="' + (card.href || "#") + '" class="special-offer-card" tabindex="-1" style="text-decoration: none; color: inherit;">\n                            <div class="special-offer-header" style="background-image:url(\'img/' + card.image + '.png\');">\n                            </div>\n                            <div class="special-offer-content">\n                                <div class="special-offer-title">' + card.title + '</div>\n                                <div class="special-offer-description">' + card.description + '</div>\n                            </div>\n                        </a>\n                    ';
                });
                html += "</div>";
            } else if (content.type === "grid" && content.columns) {
                html += '<div class="mega-content-grid">';
                content.columns.forEach((column) => {
                    if (column.type === "card") {
                        html += '\n                            <div class="mega-content-column">\n                                <a data-analytics-parent="' + content.title + '" href="' + (column.href || "#") + '" class="chemical-search-card" tabindex="-1">\n                                    <img src="img/chemical-structure-search.png" alt="" role="decorative">\n                                    <div class="chemical-search-title">' + column.title + '</div>\n                                    <div class="chemical-search-description">' + column.description + '</div>\n                                </a>\n                            </div>\n                        ';
                    } else {
                        html += '<div class="mega-content-column">';
                        let sAL = "";
                        let hS = "h4";
                        if (!content.visible) hS = "h3";
                        if (column.shopAll) {
                            if(column.shopAllHref && column.useLocale){
                                column.shopAllHref = localeUrlPath + column.shopAllHref;
                            }
                            sAL = '<a data-analytics-parent="' + column.title + '" href="' + column.shopAllHref + '" class="shop-all-link" aria-label="' + shopOrBrowseAllText + ' ' + column.title + '">' + shopOrBrowseAllText + '</a>';
                        }
                        if (column.title) html += '<div class="title-shop-all"><' + hS + ' id="' + column.titleId + '">' + column.title + '</' + hS + '>' + sAL + '</div>';

                        if (column.links) {
                            html += "<ul>";
                            column.links.forEach((link, index) => {
                                let linkRef = false;

                                if (typeof link === "object") {
                                    const currentCountryCode = (countryCode || "").toUpperCase();

                                    if (link.showInCountry) {
                                        const allowedCountries = link.showInCountry
                                            .split(",")
                                            .map(code => code.trim().toUpperCase())
                                            .filter(Boolean);

                                        if (!allowedCountries.includes(currentCountryCode)) {
                                            return;
                                        }
                                    }

                                    // add locale to links
                                    if (link.href && link.useLocale) {
                                        linkRef = localeUrlPath + link.href;
                                    } else {
                                        linkRef = link.href;
                                    }

                                    if (link.separator) {
                                        html += '<hr>';
                                    } else if (link.class) {
                                        html += '<li><a data-analytics-parent="' + content.title + '" data-analytics-section="Horizontal Nav" data-analytics-container="' + estoreTranslation + '|' + data.parentLabel + '" data-analytics-text="' + link.text + '|' + (index + 1) + '" class="' + link.class + '" href="' + (linkRef || "#") + '" role="menuitem">' + link.text + '</a></li>';
                                    } else {
                                        html += '<li><a data-analytics-parent="' + content.title + '" data-analytics-section="Horizontal Nav" data-analytics-container="' + estoreTranslation + '|' + data.parentLabel + '" data-analytics-text="' + link.text + '|' + (index + 1) + '" href="' + (linkRef || "#") + '" role="menuitem">' + link.text + '</a></li>';
                                    }
                                } else {
                                    // Fallback for old string format
                                    html += '<li><a data-analytics-parent="' + column.title + '" data-analytics-section="Horizontal Nav" data-analytics-container="' + estoreTranslation + '|' + data.parentLabel + '" data-analytics-text="' + link + '|' + (index + 1) + '" href="#">' + link + '</a></li>';
                                }
                            });
                            html += "</ul>";
                        }
                        html += "</div>";
                    }
                });
                html += "</div>";
            }

            dropdownMain.innerHTML = html;
        }

        // Desktop navigation with improved accessibility
        const navItems = document.querySelectorAll(".nav-item");

        navItems.forEach((item, index) => {
            const navLink = item.querySelector(".nav-link");

            // Handle click events
            item.addEventListener("click", function(e) {
                if(e.target.hasAttribute('data-linkonly')){
                    return;
                }
                e.preventDefault();

                if (this.classList.contains("active") && currentActiveIndex === index) {
                    closeUniversalDropdown();
                    return;
                }

                openUniversalDropdown(index);
            });

            // Handle keyboard events on nav links
            navLink.addEventListener("keydown", function(e) {
                //Submit links with enter or space if link only
                if(e.target.hasAttribute('data-linkonly')){
                    if (e.key === "Enter" || e.key === " "){
                        return;
                    }
                    if(e.key === 'ArrowDown'){
                        e.preventDefault();
                        return;
                    }
                }
                if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
                    e.preventDefault();
                    if (item.classList.contains("active") && currentActiveIndex === index) {
                        closeUniversalDropdown();
                        return;
                    }
                    openUniversalDropdown(index);
                } else if (e.key === "Escape") {
                    closeUniversalDropdown();
                } else if (e.key === "ArrowDown" && item.classList.contains("active")) {
                    e.preventDefault();
                    // Focus first element in dropdown
                    const firstTabbable = universalDropdown.querySelector("a, button");
                    if (firstTabbable) {
                        firstTabbable.focus();
                    }
                } else if (e.key === "ArrowRight" && navItems[index + 1]) {
                    navItems[index + 1].querySelector(".nav-link").focus();
                } else if (e.key === "ArrowLeft" && navItems[index - 1]) {
                    navItems[index - 1].querySelector(".nav-link").focus();
                }
            });
        });

        // Handle tab navigation within dropdown
        document.addEventListener("keydown", function() {
            if (universalDropdown.classList.contains("active")) { //if dropdown is open

                const activeNavItem = document.querySelector(".nav-item.active .nav-link");
                let activeSidebarItem = document.querySelector(".sidebar-item.active");
                const sidebarElements = dropdownSidebar.querySelectorAll('a, button, [tabindex="0"], .dropdown-footer a');
                const mainElements = dropdownMain.querySelectorAll('a, button, [tabindex="0"]');
                const firstMain = mainElements[0];
                let noSidebar = false;

                //Because there may be no side bar, lets reassign activeSidebarItem to activeNavItem
                if(!activeSidebarItem){
                    activeSidebarItem = activeNavItem;
                    noSidebar = true;
                }
                if(sidebarElements){
                    sidebarElements.forEach((item, index) => {
                        item.addEventListener("keydown", function(e) {
                            if (e.key === "ArrowDown" && sidebarElements[index + 1]) {
                                sidebarElements[index + 1].focus();
                            } else if (e.key === "ArrowDown" && !sidebarElements[index + 1]) {
                                firstMain.focus();
                            } else if (e.key === "ArrowUp" && sidebarElements[index - 1]) {
                                sidebarElements[index - 1].focus();
                            } else if (e.key === "ArrowUp" && !sidebarElements[index - 1]) {
                                e.preventDefault();
                                closeUniversalDropdown();
                                activeNavItem.focus();
                            } else if (e.shiftKey && e.key === "Tab" && !sidebarElements[index - 1]) {
                                e.preventDefault();
                                closeUniversalDropdown();
                                activeNavItem.focus();
                            }
                        });
                    });
                }


                mainElements.forEach((item, index) => {
                    const le = mainElements.length;
                    item.addEventListener("keydown", function(e) {
                        if (e.key === "ArrowLeft") {
                            activeSidebarItem.focus();
                            if(noSidebar){
                                closeUniversalDropdown();
                            }
                        } else if (e.key === "ArrowUp" && mainElements[index - 1]) {
                            mainElements[index - 1].focus();
                        } else if (e.key === "ArrowUp" && !mainElements[index - 1]) {
                            e.preventDefault();
                            activeSidebarItem.focus();
                            if(noSidebar){
                                closeUniversalDropdown();
                            }
                        } else if (e.shiftKey && e.key === "Tab" && mainElements[index - 1]) {
                            e.preventDefault();
                            mainElements[index - 1].focus();
                        } else if (e.shiftKey && e.key === "Tab" && !mainElements[index - 1]) {
                            e.preventDefault();
                            activeSidebarItem.focus();
                            if(noSidebar){
                                closeUniversalDropdown();
                            }
                        } else if (e.key === "ArrowDown" && mainElements[index + 1]) {
                            mainElements[index + 1].focus();
                        } else if (e.key === "ArrowDown" && !mainElements[index + 1]) {
                            e.preventDefault();
                            closeUniversalDropdown();
                            activeNavItem.focus();
                        } else if (e.key === "Tab" && !mainElements[index + 1]) {
                            e.preventDefault();
                            closeUniversalDropdown();
                            activeNavItem.focus();
                        }
                    });
                });
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", function(e) {
            if (!e.target.closest(".navigation") && !e.target.closest(".mega-dropdown-content")) {
                closeUniversalDropdown();
            }
        });

        // Close dropdown when clicking Quick Links
        const quickLinks = document.querySelectorAll(".quick-links .link a");
        quickLinks.forEach((item, index) => {
            item.addEventListener("click", function() {
                if (universalDropdown.classList.contains("active")) {
                    closeUniversalDropdown();
                }
            });
        });

        //Close dropdown when clicking on Search
        const searchBox = document.querySelector("#searchbar__searchBox__input");
        if(searchBox){
            searchBox.addEventListener("focus", function() {
                if (universalDropdown.classList.contains("active")) {
                    closeUniversalDropdown();
                }
            });
        }

        // Escape key to close menus
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                if (universalDropdown.classList.contains("active")) {
                    closeUniversalDropdown();
                    if (lastTabbableNavItem) {
                        lastTabbableNavItem.focus();
                    }
                }
            }
        });

        // 4.2 Dropdown positioning
        const navList = Array.from(document.querySelectorAll(".nav-item"));
        const dropdownContent = document.querySelector(".mega-dropdown-content");
        const panelWidth = 500;

        function navigationSpacing() {
            currentChosenTab = this;
            let navListItemLeftOffset = 0;
            let tabLeft = this.getBoundingClientRect().left;
            /*if (window.innerWidth < 1504) {
                navListItemLeftOffset = 24;
            }
            for (let i = 0; i < navList.indexOf(this); i++) {
                navListItemLeftOffset += navList[i].offsetWidth + 8;
                if ((navListItemLeftOffset + panelWidth) > window.innerWidth) {
                    navListItemLeftOffset = navListItemLeftOffset - (panelWidth - this.offsetWidth);
                }
            }*/
            //dropdownContent.style.marginLeft = navListItemLeftOffset + 'px';
            //dropdownContent.style.left = '';

           // dropdownContent.style.marginLeft = tabLeft + 'px';
            MegaMenuController.reposition();
        }

        for (let i = 0; i < navList.length; i++) {
            navList[i].addEventListener("click", navigationSpacing);

            // assume navList is an Array (or convert NodeList -> Array first)
            const navArr = Array.from(navList); // safe: navList might be NodeList

            navArr.forEach((el, idx) => {
                el.addEventListener("keydown", function (e) {
                    if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
                        // prevent default so Space doesn't scroll the page
                        e.preventDefault();

                        // base offset (matches your original: 24 when narrow)
                        let navListItemLeftOffset = (window.innerWidth < 1504) ? 24 : 0;

                        // helper from your original code (keep same behavior)
                        function adjustRight(link) {
                            if ((navListItemLeftOffset + panelWidth) > window.innerWidth) {
                                navListItemLeftOffset = navListItemLeftOffset - (panelWidth - link) - 7;
                            }
                        }

                        // compute offsets for all items
                        const offsets = navArr.map((item, i) => {
                            const baseWidth = item.offsetWidth || 0;
                            return (i === 0) ? (baseWidth - 1 + 8) : (baseWidth + 8);
                        });

                        // build cumulative widths before each index efficiently
                        // cumulative[i] === sum of offsets[0..i-1]
                        const cumulative = new Array(offsets.length);
                        let cum = 0;
                        for (let j = 0; j < offsets.length; j++) {
                            cumulative[j] = cum;
                            cum += offsets[j];
                        }

                        // add the width of all items before the current index
                        navListItemLeftOffset += cumulative[idx];

                        // call adjustRight with the width of the current item (same as previous adjustRight(offsetWidthN))
                        adjustRight(offsets[idx]);

                        // apply margin
                        dropdownContent.style.marginLeft = navListItemLeftOffset + "px";
                    }
                });
            });

        }

        // TOP BAR STYLING

        // Shadow appearance on scroll.
        window.addEventListener("scroll", function() {
            const header = document.querySelector("header");
            if (window.pageYOffset > 45) {
                navigationBar.classList.remove("container-shadow");
                header.classList.add("container-shadow");
            } else {
                header.classList.remove("container-shadow");
                navigationBar.classList.add("container-shadow");
            }
        });

        // 4.3 Sticky bars on SinglePDP pages
        function tabNavStickyOffset(offsetValue) {

            let productTabNav = document.querySelector(".tab_nav");
            let stickyCart = document.querySelector('.sticky_cart_wrapper');
            let marginTopSubtrahend = LocalePath.getCountry().toLowerCase() === 'us' ? 1 : 3;
            //console.log('productTabNav : ', productTabNav);
            window.addEventListener("scroll", function() {
                if (productTabNav && stickyCart) {
                    if (productTabNav.classList.contains("affix") && !stickyCart.classList.contains("hide")) {
                        //productTabNav.style.marginTop = offsetValue + 'px';
                        productTabNav.style.marginTop = (stickyCart.getBoundingClientRect().top + stickyCart.getBoundingClientRect().height) - marginTopSubtrahend + 'px';
                        //console.log((stickyCart.getBoundingClientRect().top + stickyCart.getBoundingClientRect().height) -1  + 'px');
                    }
                }

            });
        }

        function tabNavStickyNavOffset(offsetValue, parent) {
            document.querySelectorAll(parent + ' > .selected > a').forEach(anchor => {
                anchor.addEventListener("click", function(event) {
                    event.preventDefault();
                    window.scrollBy(0, offsetValue);
                });
            });
        }

        if (isPDP) {
            function pDPNavBarBreakpoints() {
                navigationBar.style.marginTop = window.innerWidth <= 1024 ? "0" : (document.querySelector('.banner-disabled') ? "10px" : "0");
            }
            pDPNavBarBreakpoints();
            window.addEventListener('resize', pDPNavBarBreakpoints);

        }

        if (bodyID == "SinglePDP") {

            let productSticky = document.querySelector(".sticky_cart_wrapper");
            const stickyCartObserver = new MutationObserver(() => {
                let productSticky = document.querySelector(".sticky_cart_wrapper");
                let defaultOffset = 177;
                if (document.querySelector('.promo_price') || window.innerWidth <= 992) {
                    defaultOffset = 220;
                }
                if (productSticky && window.innerWidth >= 992) {
                    let offsetValue = productSticky.offsetHeight + defaultOffset;
                    console.log('Sticky cart offset value: ' + offsetValue);
                    tabNavStickyOffset(defaultOffset);
                    tabNavStickyNavOffset(-10, ".ind_tab_group");
                    stickyCartObserver.disconnect();
                }
            });
            stickyCartObserver.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }

        //Observer for Option buttons
        if (isPDP) {
            (() => {
                const init = () => {
                    const applyMargin = (el) => {
                        if (!(el instanceof HTMLElement) || window.innerWidth < 992) return;
                        const hasPromo = !!document.querySelector('.promo_price');
                    };

                    // Apply to any existing wrappers
                    document.querySelectorAll('.sticky_cart_wrapper').forEach(applyMargin);

                    // Watch for wrappers added later
                    const observer = new MutationObserver((mutations) => {
                        for (const m of mutations) {
                            m.addedNodes.forEach((node) => {
                                if (!(node instanceof Element)) return;

                                // If the added node IS a wrapper
                                if (node.classList && node.classList.contains('sticky_cart_wrapper')) {
                                    tabNavStickyOffset(0);
                                    applyMargin(node);
                                }

                                // If the added node CONTAINS wrappers
                                let nested = [];

                                if (node && typeof node.querySelectorAll === 'function') {
                                    nested = node.querySelectorAll('.sticky_cart_wrapper');
                                }

                                if (nested && nested.length) {
                                    nested.forEach(applyMargin);
                                }
                            });
                        }
                    });

                    const target = document.body || document.documentElement;
                    if (target) {
                        observer.observe(target, {
                            childList: true,
                            subtree: true
                        });
                    }
                };

                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', init, {
                        once: true
                    });
                } else {
                    init();
                }
            })();
        }

        if (bodyID == "productDisplay" || bodyID == "itemDisplay") {
            tabNavStickyOffset(87);
            tabNavStickyNavOffset(-10, ".tab_nav");

        } else {
            // nothing happens
        }
        //Handle various AEM breadcrumb / hero scenarios
        const body = document.body;

        if (body.classList.contains("basicpage")) {
            const main = document.querySelector("main");
            const breadcrumb = document.querySelector(".breadcrumb");
            const heroMedium = document.querySelector(".m--hero-size-medium-responsive");

            /*if (main && breadcrumb) {  This appears to be adding twice
                main.style.top = "46px";
            }

            if (heroMedium && (breadcrumb || (main && !main.style.top))) {
                heroMedium.style.marginTop = "46px";
            }*/

            if (main && breadcrumb) {
                main.style.top = "46px";
            } else if (heroMedium && (breadcrumb || main)) {
                heroMedium.style.marginTop = "46px";
            }
        }

        if (bodyID === "fs") {
            if (document.querySelector(".main-cart-section")) {
                document.querySelector("#main").style.marginTop = "0";
            }
        }

    } // end of navLogic function



    // 4) LOAD DEPENDING ON SCREEN SIZES

    function checkScreenSize() {
        const horizontalNav = document.querySelector("#main-horizontal-nav");
        if (window.innerWidth < 992) {
            // since mobile is currently not part of A/B test we are using current MegaNav for mobile
            hideDrawer("show");

            if(horizontalNav){
                horizontalNav.classList.add("d-none");
            }

            //adjust margin for hero
            if(aemContainer){
                if(hero){
                    hero.style.marginTop = "0";
                } else {
                    aemContainer.removeAttribute('style');
                }
            }
        } else if (window.innerWidth >= 992) {
            if(horizontalNav){
                horizontalNav.classList.remove("d-none");
            }
            if(aemContainer){
                if(hero) {
                    hero.style.marginTop = `${heroMargin}px`;
                } else {
                    if(!hasBreadcrumb){
                        aemContainer.style.setProperty("margin-top", `${aemContainerMargin}px`, "important");
                    }
                }
            }
            hideDrawer("hide");
            if (!document.querySelector(".navigation")) {
                buildNav();
                navLogic();
            }
        }
    }

    //Generic function to handle spacing issues on various pages
    function normalizeSpacing() {
        const isCart = !!document.querySelector('.main.cart-checkout-ui-main');
        const isPDP = !!document.querySelector('.breadcrumbs_wrap');
        const isConfigurator = !!document.querySelector('#configuratorContainer');

        //This will push the Cart title header down
        if(isCart){
            const cartContainer = document.querySelector('.main.cart-checkout-ui-main');
            cartContainer.classList.add('p-top-10');
        }
        //This will naturally adjust the breadcrumbs
        if(isPDP){
            if(document.querySelectorAll('core-breadcrumb').length > 0){
                document.querySelector('.breadcrumbs_wrap').classList.add('m-top-24');
            }
        }

        //Adjust generic configurator landing page(s)
        if(isConfigurator){
            document.querySelector('#configuratorContainer').classList.add('m-top-24');
        }
    }

    checkScreenSize();
    normalizeSpacing();

    window.addEventListener('resize', checkScreenSize);

    //Add analytics
    const navLinks = document.querySelectorAll('.nav-item a');

    // Loop through each <a> element
    navLinks.forEach((link, index) => {
        // Set the data-analytics-text attribute for all header links
        const linkText = link.textContent.trim();
        link.setAttribute('data-analytics-section', 'Horizontal Nav');
        link.setAttribute('data-analytics-parent', '');
        link.setAttribute('data-analytics-container', estoreTranslation);
        link.setAttribute('data-analytics-text', linkText + '|' + (index + 1));
    });

    //estore listener
    var estoreElements = document.querySelectorAll('[data-estore-cookie-banner]');
    if (estoreElements) {
        estoreElements.forEach(function(element) {
            element.addEventListener('click', function(event) {
                var estoreCookie = this.getAttribute('data-estore-cookie-banner');

                if (estoreCookie) {
                    var cookieOptions = {
                        expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000), // 180 days
                        path: '/',
                        sameSite: 'None',
                        secure: true
                    };

                    window.utils.setCookie('estore', estoreCookie, cookieOptions);
                    console.log('Estore cookie set to:', estoreCookie);
                }
            });
        });
    }


} // end of switchToAltHeader function




// --- Positioning controller (small, self-contained) ---
const MegaMenuController = (function () {
    const DESKTOP_MIN = 992;
    const EDGE_PAD = 8;
    const TAB_OFFSET = 0;
    let menuEl = null;
    let moNav = null;
    let ticking = false;
    let initialized = false;

    function isVisible(el) {
        if (!el) return false;
        const cs = getComputedStyle(el);
        if (cs.display === "none" || cs.visibility === "hidden") return false;
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
    }

    function getActiveTab() {
        return document.querySelector("div.nav-item.active");
    }

    function positionNow() {
        if (!menuEl || window.innerWidth < DESKTOP_MIN) return;
        //if (!isVisible(menuEl)) return;
        const activeTab = getActiveTab();
        if (!activeTab) return;

        // Clear any sticky inline styles (start clean for measurement)
        menuEl.style.left = "";
        menuEl.style.right = "";
        menuEl.style.marginLeft = "";
        menuEl.style.position = "fixed";

        const tabRect = activeTab.getBoundingClientRect();
        const menuRect = menuEl.getBoundingClientRect();
        const vw = window.innerWidth;

        let left = tabRect.left - TAB_OFFSET;

        // flip if would overflow
        if (left + menuRect.width > vw - EDGE_PAD) {
            left = tabRect.right - menuRect.width;
        }

        // clamp
        const minLeft = EDGE_PAD;
        const maxLeft = Math.max(EDGE_PAD, vw - menuRect.width - EDGE_PAD);
        left = Math.max(minLeft, Math.min(left, maxLeft));

        menuEl.style.left = Math.round(left) + "px";
    }

    function schedulePosition() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            positionNow();
            ticking = false;
        });
    }

    function handleResize() { schedulePosition(); }
    function handleScroll() { schedulePosition(); }

    function observeNavChanges() {
        const navRoot = document.querySelector("#fs > nav");
        if (!navRoot) return;
        // observe class changes & subtree changes so active tab changes reposition menu
        moNav = new MutationObserver(() => {
            // double RAF to wait for layout/class updates
            requestAnimationFrame(() => requestAnimationFrame(schedulePosition));
        });
        moNav.observe(navRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }

    return {
        init() {
            if (initialized) return;          // idempotent
            menuEl = document.querySelector(".mega-dropdown-content");
            if (!menuEl) return;             // fail silently if menu not present yet
            initialized = true;

            // Attach listeners only while controller is initialized
            window.addEventListener("resize", handleResize, { passive: true });
            window.addEventListener("scroll", handleScroll, { passive: true, capture: true });

            observeNavChanges();

            // Position now in case it's already open
            requestAnimationFrame(() => requestAnimationFrame(positionNow));
        },

        destroy() {
            initialized = false;
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll, { capture: true });
            if (moNav) { moNav.disconnect(); moNav = null; }
            if (menuEl) {
                menuEl.style.left = "";
                menuEl.style.right = "";
                menuEl.style.marginLeft = "";
                // optional: menuEl.style.position = "";
            }
            menuEl = null;
            ticking = false;
        },

        reposition() {
            if (!initialized) return;
            schedulePosition();
        }
    };
})();

// --- Integrate controller into your initWhenReady() flow ---
function initWhenReady() {
    const observer = new MutationObserver(() => {
        if (document.querySelector("header") &&
            document.querySelector('#mobileNav') &&
            document.querySelector("#fs-headerfooter-hbr") &&
            !document.querySelector(".fallback-banner")){

            observer.disconnect();
        }
    });

    switchToAltHeader();

    // Initialize the mega menu controller after header is switched
    MegaMenuController.init();

    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback timeout
    setTimeout(() => observer.disconnect(), 5000);

    // Listen to see if banner gets removed due to no response
    document.addEventListener("bannerRemoved", (e) => {
        switchToAltHeader();
        const megaDropdown = document.querySelector(".mega-dropdown");
        if (megaDropdown && !isUS) {
            megaDropdown.classList.add("no-banner");
        }
        if(document.querySelector('#fs-headerfooter-hbr')){
            document.querySelector('#fs-headerfooter-hbr').classList.remove("kmd-d-justify-center");
        }
        // also initialize controller when bannerRemoved path runs
        MegaMenuController.init();
    });
}

// If you already have other hooks for opening/closing the menu, call:
// MegaMenuController.reposition();  // when active tab changes or menu opens
// MegaMenuController.destroy();     // if you completely tear down the header


//TODO build array of filters like banner, but for hiding nav
if(env.isLiteHeader){
    //do nothing
} else {
    initWhenReady();
}





